<div class="wrapper-page-landing">
  <div class="zc-container">
    <div class="grid">
      <div class="grid__l-6">
        <div class="wrapper-hero-section">
          <div class="wrapper-content-hero-section">
            <span class="title-hero-section">{{'HOME.birthday_party_organization' | translate}}</span>
            <span class="subtitle-hero-section">{{'HOME.organize_the_perfect_birthday_without_stress_or_wasting_time' | translate}} <br> {{'HOME.your_birthday_your_rules_your_organization' | translate}}</span>
            <div class="wrapper-button-hero-section">
              <a target="_blank" href="https://apps.apple.com/rs/app/moj-rodjendan/id6741870230"><img src="../../../../assets/icons/landing/app-store-icon.svg" alt="app store"></a>
              <a target="_blank" href="https://play.google.com/store/apps/details?id=com.mojrodjendan.app"><img src="../../../../assets/icons/landing/google-play-icon.svg" alt="google play"></a>
            </div>
          </div>

        </div>
      </div>
      <div class="grid__l-6 display-none-animation-mobile">
        <div class="wrapper-animation-hero">
<!--          <div class="background-gradient"></div>-->
          <div class="image-hero-animation">
            <img src="../../../../assets/icons/landing/hero-animation/image-hero-animation.png" alt="Pozadinska slika animacije">
          </div>
          <div class="square1 flex items-center justify-center"><img
            src="assets/icons/landing/hero-animation/game-room-icon.svg" alt="ikonica igraonice"></div>
          <div class="square2 flex items-center justify-center">
            <img src="../../../../assets/icons/landing/icon-star-white.svg" alt="ikonica zvezda">
          </div>
          <div class="square3 flex items-center justify-center">
            <img src="../../../../assets/icons/landing/icon-star-white.svg" alt="ikonica zvezda">
          </div>
          <div class="square4 flex items-center justify-center"><img
            src="assets/icons/landing/hero-animation/catering-icon.svg" alt="ikonica ketering"></div>
          <div class="square5 flex items-center justify-center"><img
            src="assets/icons/landing/hero-animation/decoration-icon.svg" alt="ikonica dekoracije"></div>
          <div class="square6 flex items-center justify-center"><img
            src="assets/icons/landing/hero-animation/gifts-icon.svg" alt="ikonica pokloni"></div>
<!--          <div class="square7 flex items-center justify-center"></div>-->
<!--          <div class="square8 flex items-center justify-center"></div>-->
<!--          <div class="square9 flex items-center justify-center"></div>-->
          <div class="square10 flex items-center justify-center"><img
            src="assets/icons/landing/hero-animation/photographer-icon.svg" alt="ikonica fotograf"></div>
          <div class="square11 flex items-center justify-center">
            <img src="assets/icons/landing/hero-animation/cakes-icon.svg" alt="ikonica torte">
          </div>
          <div class="square12 flex items-center justify-center"><img
            src="assets/icons/landing/hero-animation/animators-icon.svg" alt="ikonica animatori"></div>
          <!--                    <div class="ball-1">-->
          <!--                        <img src="assets/images/ball-1.png" alt="">-->
          <!--                    </div>-->
          <!--                    <div class="ball-2">-->
          <!--                        <img src="assets/images/ball-2.png" alt="">-->
          <!--                    </div>-->
          <!--                    <div class="ball-3">-->
          <!--                        <img src="assets/images/ball-3.png" alt="">-->
          <!--                    </div>-->
        </div>
      </div>
    </div>
  </div>
  <div class="zc-container">
    <!-- Section categories -->
    <div class="grid">
      <div class="grid__s-12">
        <div class="wrapper-categories-flip-cards">
          <a *ngFor="let banner of bannerA" (mouseenter)="hoveredCategoryBanner = banner" [href]="banner.link" target="_blank" class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <img [src]="'../../../../assets/images/landing/banners/banner' + banner.position + '.png'" alt="podrazumevane ikonice">
                <span>{{ banner?.name }}</span>
              </div>
              <div class="flip-card-back">
                <img
                  [src]="banner.image.full_path"
                  alt="pozadinska fotografija">
              </div>
            </div>
          </a>
        </div>
        <div class="grid__s-12">
          <div class="wrapper-text-categories-card">
            <span class="title-category">{{ hoveredCategoryBanner?.name }}</span>
            <span class="description-category">{{hoveredCategoryBanner?.description}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="zc-container">
    <!-- Section three steps home page  -->
    <div class="three-steps-home">
      <div class="grid">
        <div class="grid__s-12">
          <div class="wrapper-title red">
            <h2>{{'HOME.organization_in' | translate}} <span>{{'HOME.a_few_steps' | translate}}</span></h2>
          </div>
          <div class="wrapper-subtitle">
            <p>{{'HOME.without_nervousness' | translate}}</p>
          </div>
        </div>
        <div class="grid__s-12">
          <div class="wrapper-home-steps">
            <div class="home-step">
              <img src="../../../../assets/images/landing/home-step-illustration1.svg" alt="Pronadji mesto i vreme">
              <h4>{{'HOME.find' | translate}} <br> {{'HOME.place_and_time' | translate}}</h4>
              <p>{{'HOME.choose_the_playroom_that_suits' | translate}}</p>
            </div>
            <img class="line-step-home" src="../../../../assets/images/landing/line-step.svg" alt="linija">
            <div class="home-step">
              <img src="../../../../assets/images/landing/home-step-illustration2.svg" alt="naruci tortu i hranu">
              <h4>{{'HOME.order' | translate}} <br> {{'HOME.cake_and_food' | translate}}</h4>
              <p>{{'HOME.choose_your_favorite_cake' | translate}}</p>
            </div>
            <img class="line-step-home" src="../../../../assets/images/landing/line-step.svg" alt="linija">
            <div class="home-step">
              <img src="../../../../assets/images/landing/home-step-illustration3.svg" alt="pozeli zelju i slavi lagano">
              <h4>{{'HOME.make_a_wish_and' | translate}} <br> <span>{{'HOME.celebrate_lightly' | translate}}</span></h4>
              <p>{{'HOME.create_invitations_share_a_wish_list' | translate}}</p>
            </div>
          </div>
        </div>
      </div>
        <!-- Section video -->
        <div style="display: none;" class="grid">
          <div class="grid__s-12">
            <div class="wrapper-video-home-page">
              <video
                #videoPlayer
                *ngIf="homepageVideoUrl"
                playsinline
                webkit-playsinline
                width="100%"
                height="auto"
                preload="metadata"
                [src]="homepageVideoUrl"
                type="video/mp4"
              >
                Your browser does not support the video tag.
              </video>
              <div *ngIf="homepageVideoUrl && isPaused" class="custom-play-btn" (click)="playVideo()">
                <img src="../../../../assets/icons/landing/icon-play-btn.svg" alt="Dugme za pustanje video klipa">
              </div>
              <div *ngIf="homepageVideoUrl && !isPaused" class="custom-play-btn" (click)="pauseVideo()">
                <img src="../../../../assets/icons/landing/icon-pause-btn.svg" alt="Dugme za pauziranje video klipa">
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
  <div class="zc-container">
    <!-- Buy a gifts section -->
    <div class="buy-a-gifts">
      <div class="grid">
        <div class="grid__s-12">
          <div class="wrapper-title purple">
            <h2>{{'HOME.buy' | translate}} <span>{{'HOME.gift' | translate}}</span></h2>
            <img src="../../../../assets/icons/landing/icon-title-gift.svg" alt="kupite poklon">
          </div>
        </div>
        <div class="grid__s-12 grid__ml-6">
          <div class="illustration-gift">
            <img src="../../../../assets/icons/landing/illustration/illustration-gift.svg" alt="paketici">
          </div>
        </div>
        <div class="grid__s-12 grid__ml-6">
          <div class="wrapper-cards-gifts">
            <div class="wrapper-card-gift">
              <img src="../../../../assets/icons/landing/icon-star-purple.svg" alt="ljubicasta zvezda">
              <div class="content-text">
                <span class="title-card-gift">{{'HOME.gift_shopping_has_never_been_easier' | translate}}</span>
                <span class="desc-card-gift">{{'HOME.choose_the_perfect_gift_directly_from_the_celebrants_wish_list' | translate}}</span>
              </div>
            </div>
            <div class="wrapper-card-gift">
              <img src="../../../../assets/icons/landing/icon-star-purple.svg" alt="ljubicasta zvezda">
              <div class="content-text">
                <span class="title-card-gift">{{'HOME.simple_order_tracking' | translate}}</span>
                <span class="desc-card-gift">{{'HOME.see_which_gifts_have_already_been_purchased_and_avoid_duplication' | translate}}</span>
              </div>
            </div>
            <div class="wrapper-card-gift">
              <img src="../../../../assets/icons/landing/icon-star-purple.svg" alt="ljubicasta zvezda">
              <div class="content-text">
                <span class="title-card-gift">{{'HOME.secure_online_shopping' | translate}}</span>
                <span class="desc-card-gift">{{'HOME.payment_is_made_directly_through_the_application' | translate}}</span>
              </div>
            </div>
            <div class="wrapper-store-buttons-gifts">
              <div class="wrapper-card-gift height-img">
                <a href="https://apps.apple.com/rs/app/moj-rodjendan/id6741870230">
                  <img src="../../../../assets/icons/landing/app-store-icon.svg" alt="app store">
                </a>
              </div>
              <div class="wrapper-card-gift height-img">
                <a href="https://play.google.com/store/apps/details?id=com.mojrodjendan.app">
                  <img src="../../../../assets/icons/landing/google-play-icon.svg" alt="google play">
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--  Profit section  -->
  <div class="profit-section">
    <img class="star-purple-profit-section rotating" src="../../../../assets/icons/landing/icon-star-purple.svg" alt="ikonica igraonica">
    <img class="star-gradient-profit-section" src="../../../../assets/icons/landing/icon-star-gradient.svg" alt="zvezda sa dve boje">
    <img class="star-blue-profit-section up-down" src="../../../../assets/icons/landing/icon-star-blue.svg" alt="plava zvezda">
    <div class="icon1-blue">
      <img src="../../../../assets/icons/landing/elements/icon1-blue.svg" alt="ikonica plava">
    </div>
    <div class="icon2-blue">
      <img src="../../../../assets/icons/landing/elements/icon2-blue.svg" alt="ikonica plava">
    </div>
    <div class="icon3-blue">
      <img src="../../../../assets/icons/landing/elements/icon3-blue.svg" alt="ikonica plava">
    </div>
    <div class="icon4-blue">
      <img src="../../../../assets/icons/landing/elements/icon4-blue.svg" alt="ikonica plava">
    </div>
    <div class="icon5-blue">
      <img src="../../../../assets/icons/landing/elements/icon5-blue.svg" alt="ikonica plava">
    </div>
    <div class="zc-container">
      <div class="grid">
        <div class="grid__s-12">
          <div class="wrapper-title blue">
            <h2>{{'HOME.why_is_it' | translate}} <span>{{'HOME.easier' | translate}}</span> {{'HOME.with_us' | translate}} ...</h2>
          </div>
        </div>
        <div class="grid__s-12">
          <div class="wrapper-mockup-section">
            <div class="wrapper-mockup-iphone mockup-mobile">
              <img class="main-img-ios-mockup"
                   src="../../../../assets/icons/landing/iphone-mockup-illustration.png" alt="fotografija mobilnog telefona">
            </div>
            <div class="wrapper-mockup-info">
              <div class="item-mockup-info">
                <span class="title-mockup">{{'HOME.secure_payment' | translate}}</span>
                <span class="desc-mockup">{{'HOME.all_transactions_are_protected_and_carried_out_through_certified_payment_systems' | translate}}</span>
              </div>
              <div class="item-mockup-info">
                <span class="title-mockup">{{'HOME.ossibility_of_charging_a_deposit' | translate}}</span>
                <span class="desc-mockup">{{'HOME.we_have_enabled_users_to_pay_only_a_deposit_and_thus_secure_their' | translate}}</span>
              </div>
              <div class="item-mockup-info">
                <span class="title-mockup">{{'HOME.the_application_is_free' | translate}}</span>
                <span class="desc-mockup">{{'HOME.there_is_no_cost_to_use_the_app_you_only_pay_when_you_book_something' | translate}}</span>
              </div>
            </div>
            <div class="wrapper-mockup-iphone mockup-desktop">
              <img class="main-img-ios-mockup"
                   src="../../../../assets/icons/landing/iphone-mockup-illustration.png" alt="fotografija mobilnog telefona">
              <img class="arrow-icon-1" src="../../../../assets/icons/landing/icon-arrow-1.svg" alt="strelica jedan">
              <img class="arrow-icon-2" src="../../../../assets/icons/landing/icon-arrow-2.svg" alt="strelica dva">
              <img class="arrow-icon-3" src="../../../../assets/icons/landing/icon-arrow-3.svg" alt="strelica tri">
              <img class="arrow-icon-4" src="../../../../assets/icons/landing/icon-arrow-4.svg" alt="strelica cetiri">
              <img class="arrow-icon-5" src="../../../../assets/icons/landing/icon-arrow-5.svg" alt="strelica pet">
              <img class="arrow-icon-6" src="../../../../assets/icons/landing/icon-arrow-6.svg" alt="strelica sest">
            </div>
            <div class="wrapper-mockup-info">
              <div class="item-mockup-info">
                <span class="title-mockup">{{'HOME.you_pay_the_same_as_in_the_store' | translate}}</span>
                <span class="desc-mockup">{{'HOME.all_prices_in_the_app_are_the_same_as_in_stores_and_with_our_partners' | translate}}</span>
              </div>
              <div class="item-mockup-info">
                <span class="title-mockup">{{'HOME.electronic_records_and_notifications' | translate}}</span>
                <span class="desc-mockup">{{'HOME.all_reservations_confirmations_and_notifications_are_automatically_saved_and_delivered_to_your_email_in_real_time' | translate}}.</span>
              </div>
              <div class="item-mockup-info">
                <span class="title-mockup">{{'HOME.all_reservations_in_one_place' | translate}}</span>
                <span class="desc-mockup">{{'HOME.view_everything_you_have_scheduled' | translate}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--  Largest business partners section -->
  <div class="zc-container">
    <div class="wrapper_largest_business_partners">
      <div class="grid">
        <div class="grid__s-12">
          <span class="small-title">{{'HOME.Our_business_partners' | translate}}</span>
        </div>
      </div>
      <div class="grid">
        <div *ngFor="let partner of businessPartners" class="grid__m-4">
          <a *ngIf="banners.B?.length && banners.B[partner]" [href]="banners.B[partner]?.link" target="_blank">
            <div class="wrapper-banner-image-largest-business">
              <img [src]="banners.B[partner]?.image.full_path" alt="fotografija reklame">
            </div>
          </a>
          <div *ngIf="!banners.B?.length || !banners.B[partner]" class="wrapper-banner-empty">
            <img class="yellow-icon-banner" src="../../../../assets/icons/landing/illustration/illustration-yellow-empty-banner.svg" alt="zuta ilustracija na mesto za reklamu">
            <img class="r-empty-banner" src="../../../../assets/icons/landing/illustration/illustration-r-empty-banner.svg" alt="r logo moj rodjendan">
            <div class="content-empty-banner">
              <img src="../../../../assets/icons/landing/illustration/white-r.svg" alt="belo slovo r">
              <span>{{'GLOBAL.place_for' | translate}}</span>
              <span><b>{{'GLOBAL.your_advertisement' | translate}}</b></span>
            </div>
          </div>
        </div>
        <div class="grid__s-12">
          <div class="wrapper-become-our-partner">
            <span>{{'HOME.become_our_partner' | translate}}</span>
            <button [routerLink]="[PAGES_AND_PATHS.landingForBusinesses.pagePath]" class="custom-btn custom-btn--outline">
              <span>{{'GLOBAL.for_businesses' | translate}}</span>
              <img src="../../../../assets/icons/landing/arrow-right.svg" alt="strelica u desno">
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="zc-container">
    <div class="wrapper-landing-blogs">
      <div class="grid">
        <div class="grid__s-12">
          <span class="small-title">{{'HOME.interesting_facts_on_the_blog' | translate}}</span>
        </div>
      </div>
      <div class="grid">
        <div *ngFor="let blog of blogs" class="grid__m-4">
          <div class="wrapper-card-blog">
            <div class="wrapper-header-card-blog">
              <img [src]="blog.image.full_path" alt="fotografija bloga">
            </div>
            <div class="wrapper-content-card-blog">
              <div class="zc-d-flex zc-align-items">
                <div class="wrapper-category-label" [ngClass]="blog.category | lowercase">
                  <span>{{ blog.category }}</span>
                </div>
                <span class="time-card-blog">{{blog.created_at | timeAgo}}</span>
              </div>
              <span class="title-landing-blog-card length-character-column length-character-column--2">{{blog.title}}</span>
              <span class="subtitle-landing-blog-card length-character-column length-character-column--2" [innerHTML]="blog.intro_text"></span>
              <span class="link-blue-text" [routerLink]="[PAGES_AND_PATHS.landingSingleBlog.pagePath, blog.id]">{{'GLOBAl.read' | translate}}...</span>
            </div>
          </div>
        </div>
        <div class="grid__s-12">
          <div [routerLink]="[PAGES_AND_PATHS.landingBlog.pagePath]" class="view-more-btn">
            <span>{{'HOME.view_all' | translate}}</span>
            <img src="../../../../assets/icons/landing/arrow-right.svg" alt="strelica u desno">
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="banners.C?.length" class="zc-container-fluid slider_business_partners">
    <div class="wrapper-icon-slider-business-partner">
      <img src="../../../../assets/icons/landing/icon-star-blue.svg" alt="plava zvezdica">
    </div>
    <div class="wrapper-icon-slider-business-partner-red">
      <img src="../../../../assets/icons/landing/icon-star-blue.svg" alt="plava zvezdica">
    </div>
    <div class="zc-container">
      <div class="grid">
        <div class="grid__s-12">
          <div class="wrapper-title-business-partners">
            <span class="title-slider-business-partners">{{'HOME.our_partners' | translate}}</span>
            <div class="wrapper-arrows">
              <img (click)="slickModal.slickPrev()" class="xs-mr-10" src="../../../../assets/icons/landing/icon-arrow-left-slider.svg" alt="strelica levo">
              <img (click)="slickModal.slickNext()" src="../../../../assets/icons/landing/icon-arrow-right-slider.svg" alt="strelica desno">
            </div>
          </div>
        </div>
        <div class="grid__s-12">
          <ngx-slick-carousel class="carousel" #slickModal="slick-carousel"  [config]="slideConfig">
            <div ngxSlickItem *ngFor="let slide of banners.C" class="slide">
              <a *ngIf="slide.image.full_path" [href]="slide.link" target="_blank">
                <img src="{{ slide.image.full_path }}" alt="slide" style="width: 100%;">
              </a>
              <div *ngIf="!slide.image.full_path" class="wrapper-banner-empty partners">
                <img class="yellow-icon-banner" src="../../../../assets/icons/landing/illustration/illustration-yellow-empty-banner.svg" alt="ilustracija za prazan baner">
                <img class="r-empty-banner" src="../../../../assets/icons/landing/illustration/illustration-r-empty-banner.svg" alt="sivo r">
                <div class="content-empty-banner">
                  <img src="../../../../assets/icons/landing/illustration/white-r.svg" alt="belo r">
                  <span>{{'GLOBAL.place_for' | translate}}</span>
                  <span><b>{{'GLOBAL.your_advertisement' | translate}}</b></span>
                </div>
              </div>
            </div>
          </ngx-slick-carousel>
        </div>
      </div>
    </div>
  </div>
  <!--  User experiences section  -->
  <div class="wrapper-user-experiences-section">
    <div class="zc-container">
      <div class="grid">
        <div class="grid__s-12">
          <div class="wrapper-title user-experience">
            <h2>{{'HOME.user_experiences' | translate}}</h2>
            <img src="../../../../assets/icons/landing/illustration/illustration-user-experiences.svg" alt="ilustracija iskustva korisnika">
          </div>
        </div>
        <div *ngIf="userExperiences.length" class="grid__l-4">
          <div class="wrapper-card-user-experience">
            <div class="wrapper-header-card-user-experiences">
              <span>{{ userExperiences[0].description }}</span>
            </div>
            <div class="wrapper-footer-card-user-experiences">
              <div class="wrapper-rating">
                <img src="../../../../assets/icons/landing/star-rating.svg" alt="ocena korisnika">
                <img src="../../../../assets/icons/landing/star-rating.svg" alt="ocena korisnika">
                <img src="../../../../assets/icons/landing/star-rating.svg" alt="ocena korisnika">
                <img src="../../../../assets/icons/landing/star-rating.svg" alt="ocena korisnika">
                <img src="../../../../assets/icons/landing/star-rating.svg" alt="ocena korisnika">
              </div>
              <div class="wrapper-author">
                <img [src]="userExperiences[0].image.full_path" alt="slika autora recenzije">
                <span>{{ userExperiences[0].author }}</span>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="userExperiences.length > 1" class="grid__l-4">
          <div class="wrapper-card-user-experience">
            <div class="wrapper-header-card-user-experiences">
              <span>{{ userExperiences[1].description }}</span>
            </div>
            <div class="wrapper-footer-card-user-experiences">
              <div class="wrapper-rating">
                <img src="../../../../assets/icons/landing/star-rating.svg" alt="ocena korisnika">
                <img src="../../../../assets/icons/landing/star-rating.svg" alt="ocena korisnika">
                <img src="../../../../assets/icons/landing/star-rating.svg" alt="ocena korisnika">
                <img src="../../../../assets/icons/landing/star-rating.svg" alt="ocena korisnika">
                <img src="../../../../assets/icons/landing/star-rating.svg" alt="ocena korisnika">
              </div>
              <div class="wrapper-author">
                <img [src]="userExperiences[1].image.full_path" alt="slika autora recenzije">
                <span>{{ userExperiences[1].author }}</span>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="userExperiences.length > 2" class="grid__l-4">
          <div class="wrapper-card-user-experience">
            <div class="wrapper-header-card-user-experiences">
              <span>{{ userExperiences[2].description }}</span>
            </div>
            <div class="wrapper-footer-card-user-experiences">
              <div class="wrapper-rating">
                <img src="../../../../assets/icons/landing/star-rating.svg" alt="ocena korisnika">
                <img src="../../../../assets/icons/landing/star-rating.svg" alt="ocena korisnika">
                <img src="../../../../assets/icons/landing/star-rating.svg" alt="ocena korisnika">
                <img src="../../../../assets/icons/landing/star-rating.svg" alt="ocena korisnika">
                <img src="../../../../assets/icons/landing/star-rating.svg" alt="ocena korisnika">
              </div>
              <div class="wrapper-author">
                <img [src]="userExperiences[2].image.full_path" alt="Slika autora recenzije">
                <span>{{ userExperiences[2].author }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- FAQ section -->
  <div class="wrapper-faq-section">
    <div class="zc-container">
      <div class="grid">
        <div class="grid__s-12">
          <div class="wrapper-faq">
            <div class="social-media-box social-media-box--1">
              <img src="../../../../assets/icons/landing/icon-star-blue.svg" alt="plava zvezdica">
            </div>
            <div class="wrapper-title faq">
              <h2>{{'HOME.frequent' | translate}} <span>{{'HOME.questions' | translate}}</span></h2>
              <img src="../../../../assets/icons/landing/illustration/faq-illustration.svg" alt="cesta pitanja">
            </div>
            <div class="wrapper-content-faq">
              <div *ngFor="let faq of faqs; index as faqIndex" class="wrapper-question" (click)="faqIndex === activeFaqIndex ? activeFaqIndex = -1 : activeFaqIndex = faqIndex" [ngClass]="{'collapsed': faqIndex === activeFaqIndex}">
                <span class="title-question">{{ faq.question }}</span>
                <span class="description-answer">{{faq.answer}}</span>
                <img class="icon-star-green rotating" src="../../../../assets/icons/landing/icon-star-green.svg" alt="zelena zvezdica">
                <img class="icon-blue plus" src="../../../../assets/icons/landing/icon-plus-blue.svg" alt="plavi plus">
                <img class="icon-blue minus" src="../../../../assets/icons/landing/Icon-minus-blue.svg" alt="plavi minus">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Newsletter section -->
  <div class="wrapper-newsletter">
    <span class="title-newsletter">{{'HOME.sign_up_and_get_the_latest_information' | translate}}</span>
    <span class="subtitle-newsletter">{{'HOME.sign_up_and_be_the_first_to_know_about_new_games_gifts_and_promotions' | translate}}</span>
    <form [formGroup]="newsletterForm" (ngSubmit)="onSubmitPostNewsletterForm()" class="form-newsletter">
      <div class="wrapper-input-landing">
        <div class="custom-input">
          <input [formControl]="newsletterForm.controls.email | formControl" type="text" placeholder="">
        </div>
        <!--     TODO TRANSLATE ZOCA      -->
        <span class="error-message">{{newsletterForm.controls.email | formControlErrorMessages: 'Unesite validnu email adresu.' : newsletterFormTriedToSubmit}}</span>
      </div>
      <button type="submit" class="custom-btn custom-btn--primary">
        <span>{{'GLOBAL.send' | translate}}</span>
      </button>
    </form>
  </div>
  <div class="moving-tape-section">
    <div class="wrapper-slider-auto">
      <div class="wrapper-slider-image">
        <a *ngFor="let mediumPartnerBanner of banners.D" [href]="mediumPartnerBanner.link" target="_blank">
          <img [src]="mediumPartnerBanner.image.full_path" alt="gotoghrafija banera">
        </a>
      </div>
      <div class="wrapper-slider-image">
        <a *ngFor="let mediumPartnerBanner of banners.D" [href]="mediumPartnerBanner.link" target="_blank">
          <img [src]="mediumPartnerBanner.image.full_path" alt="fotografija banera">
        </a>
      </div>
    </div>
  </div>
</div>
